<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>DATA PEGAWAI</h4>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  // eslint-disable-next-line
  name: 'jBlank',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jBlank.vue